import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Do you offer a free trial or screening?',
      answer: 'Yes! We provide a free screening for all new members. This includes a facility tour, fitness assessment, and consultation with our professional trainers to help you get started on the right path.'
    },
    {
      question: 'What are your operating hours?',
      answer: 'We are open Monday to Friday from 5:30 AM to 9:00 PM, and Saturdays from 6:00 AM to 3:00 PM. We are closed on Sundays and public holidays to allow our team to rest and maintain our facilities.'
    },
    {
      question: 'Do I need to bring my own equipment?',
      answer: 'No, we have over 100 premium machines and all the equipment you need for a complete workout. However, you are welcome to bring your own water bottle, towel, and workout gloves if you prefer.'
    },
    {
      question: 'Are personal trainers available?',
      answer: 'Yes! We have professional trainers available and ready to assist in any challenge. But in case one requires a dedicated trainer they have to pay KES 14650 inclusive of the gym membership per month.'
    },
    {
      question: 'Can beginners join HFC Gym?',
      answer: 'Absolutely! We welcome members of all fitness levels. Our trainers specialize in working with beginners and will help you learn proper techniques, build confidence, and progress safely toward your fitness goals.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-red-100 text-red-700 rounded-lg text-sm font-bold mb-4 uppercase tracking-wider">
            FAQ
          </div>
          <h3 className="text-5xl lg:text-6xl font-black text-gray-900 mb-6">
            Frequently Asked <span className="text-red-600">Questions</span>
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Got questions? We've got answers. Find everything you need to know about HFC Gym.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between gap-4 text-left hover:bg-gray-50 transition-colors duration-300"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-10 h-10 bg-gradient-to-br from-red-600 to-red-700 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-question-line text-white text-xl"></i>
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 leading-relaxed">
                    {faq.question}
                  </h4>
                </div>
                <div
                  className={`w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line text-gray-700 text-2xl"></i>
                </div>
              </button>

              <div
                className={`transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-8 pb-6 pl-[88px]">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center bg-gradient-to-br from-red-50 to-white rounded-2xl p-8 border border-red-100">
          <p className="text-gray-700 font-semibold mb-4">Still have questions?</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button
              href="tel:+254795568891"
              variant="cta"
              icon="ri-phone-line"
              iconPosition="left"
              className="px-6 py-3"
            >
              Call: 0795 568 891
            </Button>
            <Button
              href="https://wa.me/254795568891"
              target="_blank"
              rel="noopener noreferrer"
              variant="primary"
              icon="ri-whatsapp-line"
              iconPosition="left"
              className="px-6 py-3"
            >
              WhatsApp Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
